import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=4b197c60&scoped=true&"
import script from "./js/admin.js?vue&type=script&lang=js&"
export * from "./js/admin.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b197c60",
  null
  
)

export default component.exports